import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        formContainer: {
            backgroundColor: theme.palette.secondary[50],
            cursor: 'default',
            padding: theme.spacing(1),
        },
    }
})

export default useStyles
